import algosdk, { makeAssetTransferTxnWithSuggestedParamsFromObject, ALGORAND_MIN_TX_FEE } from "algosdk";
import { algodClient } from "../../App";
import { ALGOContractServices } from "../../services/contract.services";
import { AccountAssetType, addressFormate, pause } from "../../_utils";
import { toast } from "react-toastify";
import { BLOCKCHAINS, PROVIDERS } from "../providers";
import i18next from "i18next";
import BigNumber from "bignumber.js";

export type AccountType = {
  address: string,
  amount: number,
  assets: Array<{
    amount: number,
    assetId: number
  }>,
  minBalance: number,
}

export const getAccountInfo = async (address: string): Promise<AccountType> => {
  try {
    const account = await algodClient.accountInformation(address).do();
    return {
      address: account.address,
      amount: account.amount,
      assets: account.assets?.map((a: any) => ({ assetId: a['asset-id'], amount: a.amount })) || [],
      minBalance: account['min-balance'],
    };
  } catch (err) {
    console.log('ERROR IN GET ACCOUNT INFO')
  }
};

export const checkAlgoBalance = async (address: string, txCount: number) => {
  const accI = await getAccountInfo(address);
  const isEnough = BigNumber(accI.amount).minus(accI.minBalance).minus(algosdk.ALGORAND_MIN_TX_FEE * txCount).isGreaterThan(0);
  if (!isEnough) throw Error(i18next.t("error_msg.not_enough_algo", { address: addressFormate(address, 5) }));
}

export const checkAssetOptIn = async (address: string, assetIndex: number) => {
  const assetLocalState = await getAccountInfo(address);
  if (assetIndex === 0) {
    return false;
  }
  const assetInfo = assetLocalState?.assets.find((doc) => doc.assetId === assetIndex);
  if (assetInfo) {
    return false;
  }
  return true;
};

export const makeOptInTxn = async (sender: string, asset: number) => {
  const params = await algodClient.getTransactionParams().do();
  params.fee = ALGORAND_MIN_TX_FEE * 1;
  params.flatFee = true;
  const txn = makeAssetTransferTxnWithSuggestedParamsFromObject({
    amount: 0,
    from: sender,
    to: sender,
    suggestedParams: params,
    assetIndex: asset,
  });
  return txn;
};


export const makeOptInOperation = async (asset: AccountAssetType, address: string, logInChain: string, connect, toastId?: number) => {
  const index = Number(asset.index);
  const isNeedOptIn = await checkAssetOptIn(address, index);
  if (isNeedOptIn) {
    try {
      let changedConnection = false;
      if (logInChain !== BLOCKCHAINS.ALGORAND) {
        if (toastId) toast.update(toastId, { render: `${i18next.t("obd_notifications.connect_for_optin", {coin: asset.unit_name })}` });
        await pause(2000);
        await connect(BLOCKCHAINS.ALGORAND, PROVIDERS.PERA);
        changedConnection = true;
        if (toastId) toast.update(toastId, { render: i18next.t("obd_notifications.awaiting_wallet_signature").toString() });
      }
      await checkAlgoBalance(address, 1);

      const txnGroup = await makeOptInTxn(address, index);
      const response = await ALGOContractServices.sendTransaction(
        [txnGroup],
        algodClient
      );
      const info = await algosdk.waitForConfirmation(algodClient, response.txId, 4);
      const toastMsg = changedConnection
        ? "Successfully opted in. Please reconnect login wallet to continue withdrawal" 
        : `Successfully opted in. ${i18next.t("obd_notifications.awaiting_wallet_signature")}`
      if (toastId) toast.update(toastId, { render: toastMsg });
      return changedConnection;
    } catch (err) {
      throw err;
    }
  }
}
